(function () {
  var TEXT = 'Be the first to share how you’re using it';

  function mark(widget) {
    var label = widget.querySelector('.kl_reviews__star_rating_widget__label');
    var zero = label && /^\s*0\s+reviews?\s*$/i.test(label.textContent);
    var tip = widget.querySelector('.sp-review-tip');
    if (zero && !tip) {
      tip = document.createElement('span');
      tip.className = 'sp-review-tip';
      tip.setAttribute('aria-hidden', 'true');
      tip.textContent = TEXT;
      widget.appendChild(tip);
      widget.classList.add('sp-has-review-tip');
    } else if (!zero && tip) {
      tip.remove();
      widget.classList.remove('sp-has-review-tip');
    }
  }

  function scan() {
    document.querySelectorAll('.kl_reviews__star_rating_widget').forEach(mark);
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  scan();
})();
